import React, { useState, useRef } from "react";
import Ratingscale from "./Ratingscale";
import Slider from "./Slider";
import ReactDatePicker from "react-datepicker";
import Fileuploader from "./Fileuploader";

const Surveymain = ({ surveyData, handleControlChange, onSubmit }) => {
  const { questions } = surveyData;
  const [isFileDeleted, setIsFileDeleted] = useState(true);
  // Step 1: Group questions by section
  const sections = [];
  let currentSection = null;
  //Validation
  const questionRefs = useRef({});
  const [errors, setErrors] = useState({});

  questions.forEach((question) => {
    if (question.ctrl_name === "New Section") {
      // Start a new section
      currentSection = {
        sectionTitle: question.surv_ques_label,
        sectionDesc: question.surv_ques_desc,
        questions: [],
      };
      sections.push(currentSection);
    } else {
      // If no "New Section", add questions to the last section or default section
      if (!currentSection) {
        currentSection = {
          sectionTitle: "Default Section",
          sectionDesc: "",
          questions: [],
        };
        sections.push(currentSection);
      }
      // Add questions to the current section
      currentSection.questions.push(question);
    }
  });
  //console.log(questions);

  // Step 2: Pagination logic
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  const handleNext = () => {
    if (validateFields()) {
      if (currentSectionIndex < sections.length - 1) {
        setCurrentSectionIndex(currentSectionIndex + 1);
        console.log(currentSectionData);
      }
    } else {
      scrollToInvalidField();
    }
  };

  const handlePrev = () => {
    if (validateFields()) {
      if (currentSectionIndex > 0) {
        setCurrentSectionIndex(currentSectionIndex - 1);
      }
    } else {
      scrollToInvalidField();
    }

    /*if (currentSectionIndex > 0) {
      setCurrentSectionIndex(currentSectionIndex - 1);
    }*/
  };

  const currentSectionData = sections[currentSectionIndex];

  const fetchItemById = (id) => {
    const foundItem = surveyData.questions.find(
      (item) => parseInt(item.surv_ques_id) === parseInt(id)
    );

    if (foundItem) {
      // If an item with the matching id is found, you can access its values
      return foundItem.input_val; // or any other property you want
    } else {
      return "";
    }
  };
  const handleChange = (id, value, ctrl_name, checked) => {
    handleControlChange(id, value, ctrl_name, checked);
    //setErrors((error) => (error[id] = ""));
  };

  const handlesubmit = () => {
    if (validateFields()) {
      onSubmit();
    } else {
      scrollToInvalidField();
    }
  };

  // Validate required questions
  const validateFields = () => {
    let formErrors = {};

    currentSectionData.questions.forEach((question) => {
      if (
        question.is_req &&
        (!question.input_val || question.input_val === "")
      ) {
        formErrors[question.surv_ques_id] = `This is a required question`;
      }
    });

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Scroll to first invalid question
  const scrollToInvalidField = () => {
    const firstInvalidId = Object.keys(errors)[0];
    if (firstInvalidId) {
      questionRefs.current[firstInvalidId].scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const handleFileDelete = (id) => {
    console.log("handleFileDelete");
    //questions.map((question) => (question[id].input_val = ""));
    questions.forEach((question) => {
      if (question.surv_ques_id === id) {
        question.input_val = "";
      }
    });
    setIsFileDeleted((prev) => (prev === true ? false : true));
  };

  return (
    <div>
      <div className="col-xl-6 mx-auto mt-5">
        <div className="card shadow mb-4 mt-4">
          <div class="card-body">
            <h3 className="mb-3">
              {surveyData.surveyinfo?.map((item) => item.surv_name)}
            </h3>
            <hr />
            <span className="text-danger">* Indicates required questions!</span>
            &nbsp;
          </div>
        </div>
        {currentSectionData.sectionTitle !== "Default Section" && (
          <div className="card shadow mb-4 mt-4">
            <div class="card-body">
              <h5>{currentSectionData?.sectionTitle}</h5>
              <hr />
              <div
                dangerouslySetInnerHTML={{
                  __html: currentSectionData.sectionDesc
                    ? currentSectionData.sectionDesc
                    : "",
                }}
              />
              {/*currentSectionData.sectionDesc
                ? currentSectionData.sectionDesc
                : ""*/}
            </div>
          </div>
        )}
        <form>
          {currentSectionData?.questions.map((ques, index) => (
            <div>
              <div
                className="card shadow mb-3"
                ref={(el) => (questionRefs.current[ques.surv_ques_id] = el)}
              >
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                  <h6>
                    {parseInt(ques.is_req) === 1 && (
                      <i className="text-danger">*&nbsp;</i>
                    )}
                    Q.{index + 1}&nbsp;{ques.surv_ques_label}
                  </h6>
                </div>
                <div className="card-body">
                  {ques.ctrl_name === "Text Box" && (
                    <div className="row gx-3 mb-3">
                      <input
                        id={ques.surv_ques_id}
                        type="text"
                        className="form-control"
                        value={ques.input_val ? ques.input_val : ""}
                        onChange={(e) =>
                          handleChange(
                            e.target.id,
                            e.target.value,
                            ques.ctrl_name,
                            0
                          )
                        }
                      />
                    </div>
                  )}
                  {ques.ctrl_name === "Dropdown" && (
                    <div className="row gx-3 mb-3">
                      <select
                        id={ques.surv_ques_id}
                        className="custom-select mr-sm-2"
                        value={ques.input_val}
                        onChange={(e) =>
                          handleChange(
                            e.target.id,
                            e.target.value,
                            ques.ctrl_name,
                            0
                          )
                        }
                      >
                        <option>Choose...</option>
                        {ques.options?.map((opt, index) => (
                          <option value={opt.ques_opt_txt}>
                            {opt.ques_opt_txt}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {ques.ctrl_name === "Radio Button" && (
                    <div className="custom-control custom-checkbox">
                      {ques.options?.map((opt, index) => (
                        <div>
                          <input
                            name={"rdo_question_" + ques.surv_ques_id}
                            key={opt.ques_opt_id}
                            id={ques.surv_ques_id}
                            value={opt.ques_opt_txt}
                            className="form-check-input"
                            type="radio"
                            onChange={(e) =>
                              handleChange(
                                e.target.id,
                                e.target.value,
                                ques.ctrl_name,
                                0
                              )
                            }
                            checked={opt.ques_opt_txt === ques.input_val}
                          />
                          &nbsp;&nbsp; {opt.ques_opt_txt}
                        </div>
                      ))}
                    </div>
                  )}
                  {ques.ctrl_name === "Check Box" && (
                    <div className="custom-control custom-checkbox">
                      {ques.options?.map((opt, index) => (
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name={ques.surv_ques_id}
                            id={opt.ques_opt_id}
                            key={opt.ques_opt_id}
                            value={opt.ques_opt_txt}
                            onChange={(e) =>
                              handleChange(
                                ques.surv_ques_id,
                                e.target.value,
                                ques.ctrl_name,
                                e.target.checked
                              )
                            }
                            checked={ques.input_val?.includes(opt.ques_opt_txt)}
                          />
                          &nbsp;&nbsp; {opt.ques_opt_txt}
                        </div>
                      ))}
                    </div>
                  )}
                  {ques.ctrl_name === "Multiline Text" && (
                    <div className="row gx-3 mb-3">
                      <textarea
                        id={ques.surv_ques_id}
                        className="form-control"
                        value={ques.input_val ? ques.input_val : ""}
                        onChange={(e) =>
                          handleChange(
                            e.target.id,
                            e.target.value,
                            ques.ctrl_name,
                            0
                          )
                        }
                      ></textarea>
                    </div>
                  )}
                  {ques.ctrl_name === "Rating Scale" && (
                    <Ratingscale
                      quesId={ques.surv_ques_id}
                      maxRating={parseInt(ques.scale_range)}
                      onRatingChange={handleChange}
                      ctrlName={ques.ctrl_name}
                      value={ques.input_val}
                    />
                  )}
                  {ques.ctrl_name === "Slider" && (
                    <Slider
                      quesId={ques.surv_ques_id}
                      min={ques.min_range}
                      max={ques.max_range}
                      onValueChange={handleChange}
                      ctrlName={ques.ctrl_name}
                      value={ques.input_val}
                    />
                  )}
                  {ques.ctrl_name === "Date" && (
                    <div className="react-datepicker__input-container">
                      <i
                        title="Calendar"
                        className="icon fas fa-calendar-alt"
                        style={{ fontSize: 18 }}
                      ></i>
                      &nbsp;&nbsp;
                      <ReactDatePicker
                        id={ques.surv_ques_id}
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        onChange={(seldate) =>
                          handleChange(
                            ques.surv_ques_id,
                            seldate,
                            ques.ctrl_name,
                            0
                          )
                        }
                        selected={fetchItemById(ques.surv_ques_id)}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YYYY"
                      />
                    </div>
                  )}
                  {ques.ctrl_name.toUpperCase() === "FILE UPLOADER" && (
                    <div>
                      <Fileuploader
                        id={ques.surv_ques_id}
                        onUpload={handleChange}
                        fileName={
                          ques.input_val
                            ? JSON.parse(ques.input_val).file_base_name
                            : ""
                        }
                        ctrlName={ques.ctrl_name}
                        onFileDelete={handleFileDelete}
                      />
                    </div>
                  )}
                  {errors[ques.surv_ques_id] && (
                    <p className="text-danger">
                      <i className="fas fa-exclamation-circle" /> &nbsp;
                      {errors[ques.surv_ques_id]}
                    </p>
                  )}
                </div>
              </div>
              <div>&nbsp;</div>
            </div>
          ))}
        </form>
      </div>
      <div className="row gx-3 mt-3" style={{ marginLeft: "35%" }}>
        <button
          onClick={handlePrev}
          disabled={currentSectionIndex === 0}
          className="btn btn-primary align-center mx-3"
        >
          Back
        </button>
        <button
          onClick={handleNext}
          disabled={currentSectionIndex === sections.length - 1}
          className="btn btn-primary align-center mx-3"
        >
          Next
        </button>
        {currentSectionIndex === sections.length - 1 && (
          <button
            id="btn_submit"
            className="btn btn-primary align-center mx-3"
            type="button"
            data-toggle="modal"
            data-target="#surveysubmitModal"
          >
            &nbsp;&nbsp;Submit&nbsp;&nbsp;
          </button>
        )}
      </div>
      <div
        class="modal fade bd-example-modal-lg"
        id="surveysubmitModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="surveysubmitModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <span class="btn btn-warning btn-circle mb-1">
                <i class="fas fa-exclamation-circle"></i>
              </span>
              <h5>
                &nbsp;&nbsp; Are you sure, You want to Submit the survey? You
                may not come back and make changes after submission.
              </h5>
            </div>
            <div class="modal-footer">
              <button
                id="btn_publish_final"
                className="btn btn-primary align-center"
                type="button"
                onClick={() => handlesubmit()}
                data-dismiss="modal"
              >
                &nbsp;&nbsp;Submit&nbsp;&nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Surveymain;
